import React, { FC } from "react";
import { RadioStyled } from "./elements";

type RadioProps = {
  radioValue: string | boolean;
  children: React.ReactNode;
};

const Radio: FC<RadioProps> = props => {
  const { children, radioValue } = props;

  return <RadioStyled value={radioValue}>{children}</RadioStyled>;
};

export default Radio;
